import { errorMessages, NO_NUMBER_REGX } from 'screens/Mutations/constants'; // todo: move to root domain
import { string } from 'yup';

const name = string()
  .matches(NO_NUMBER_REGX, errorMessages.onlyLetterAndSpecialCharacters)
  .typeError(errorMessages.required)
  .max(250, errorMessages.max250Letters);

export default name;
